import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Seo } from '@/components/generals/seo'

const ShapeTrail = dynamic(
    () => import('@/components/landing/shape-trail').then((m) => m.ShapeTrail),
    { ssr: false }
)

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <main className='bg-background'>
                <ShapeTrail />
            </main>
        </>
    )
}

export default Home
